import TableGame from "../objects/tableGame/tableGame";
import Header from "../objects/header/header";
import SwipeZone from "../objects/tableGame/swipeZone";
import { WebSocketManager } from "../helpers/webSocketManager";
import { ReservingModal } from "../objects/modals/reservingModal";
import { AddMoreChipModal } from "../objects/modals/addMoreChipModal";
import { Chat } from "../objects/sideMenus/chat/chat";
import { RealTimeResultsMenu } from "../objects/sideMenus/realTimeResults/realTimeResultsMenu";
import { ReplayHandMenu } from "../objects/sideMenus/replayHand/replayHandMenu";
import Phaser from "phaser";
import alertify from "@/services/toast.js";
import LockScreen from "../objects/tableGame/lockScreen";
import router from "../../../routes";
import { VisibilityManager } from "../helpers/visibilityManager";
import geoLocationService from "@/services/geoLocationService";
import Swal from "sweetalert2/dist/sweetalert2.js";
import userServices from "@/services/user-services";
import { tweenConfigs } from "../helpers/tweensConfigs";
// import UIPlugin from "../plugins/rexuiplugin.min";
import * as Sentry from "@sentry/browser";
import { store } from "@/store/store";

export default class GameScene extends Phaser.Scene {
  constructor() {
    super({
      key: "GameScene",
    });
  }

  init() {
    this.events.on("destroy", () => {
      this.children.getChildren().forEach((child) => child.destroy());
      this.timeouts.forEach((t) => clearTimeout(t));
    });
    this.connectionFailedTimer = this.time.addEvent({
      delay: 10000, // ms
      callback: () => {
        router.push(`/lobby/${this.getURLClubId()}`);
        alertify.typeError("Connection failed. Please try again!");
      },
      //args: [],
      callbackScope: this,
      repeat: -1,
    });
    this.tableGames = [];
    this.totalTableGames = 1;
    this.swipeZoneList = [];
    this.positionsWereControlled = false;
    this.isSceneObjectsInteractive = true;
    this.user = {};
    this.alertify = alertify;
    // this.initialized = false;
    this.urlTableId = this.getURLTableId();
    this.urlClubId = this.getURLClubId();
    this.userTableGames = []; /* User's tables which received from server */
    this.atlasTexture = "megaSet";
    this.audioEnable = true;
    this.tweenEnable = true;
    this.autoSwitchTables = false;
    this.sound.pauseOnBlur = false;
    this.vibrationAllowed = true;
    this.expiredTables = [];
    this.expiredTableToShow = {};
    this.userLatitude = null;
    this.userLongitude = null;
    this.poolArray = [];
    this.soundsList = [];
    this.Swal = Swal;
    this.timeouts = [];
    // this.gameIsHidden = false;
  }
  preload() {
    // this.load.scenePlugin({
    //   key: "rexUI",
    //   url: UIPlugin,
    //   sceneKey: "rexUI",
    // });
    this.lockScreen = new LockScreen(this, 0);
    this.disconnectLoading = new LockScreen(this, 10);
    this.gameWidth = this.cameras.main.width;
    this.gameHeight = this.cameras.main.height;
    this.lockScreen.positionControls();
    this.disconnectLoading.positionControls();
    this.lockScreen.show("Loading");
    this.addSounds();
  }
  async create() {
    // WebSocketManager.replayGameStates();
    // await new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve();
    //   }, 400);
    // });
    WebSocketManager.connectToSocket(this);
    this.bg = this.add.image(0, 0, "bg").setOrigin(0);
    // if (WebSocketManager.socket && WebSocketManager.socket.connected){
    this.buildObjects().then(() => {});
    this.createAnimation();
    // }
  }
  prepareRegistry() {
    this.registry.set("showTournamentRebuy", false);
    this.registry.set("showTournamentResult", false);
  }

  // onRegistryChangeData(gameInstance){
  //     if(gameInstance.registry.has("showTableSetting")) {
  //         if(!gameInstance.registry.get("showTableSetting")){
  //             this.changeObjectsInteractivity(true);
  //         }
  //     }
  // }
  async buildObjects() {
    // this.initialized = true;
    this.userTableGames = [];
    this.tableGames = [];
    this.swipeZoneList = [];
    try {
      // this.user = await WebSocketManager.emitEvent(
      //   {},
      //   "poker.client-pull.user-details"
      // );
      const userInfoReq = await userServices.get("accounts/user-info-in-game");
      this.user = userInfoReq.body.data;
    } catch (e) {
      console.error(e);
    }
    // this.tableGames.push({
    //   tableGame: new TableGame(this, 1, this.urlTableId),
    //   visited: true /* The table game which is on display */,
    // });
    try {
      await this.visitTable(this.urlTableId);
      // await this.tableGames[0].tableGame.visitTable();
      // try {
      //   await this.tableGames[0].tableGame.init();
      //   this.swipeZoneList.push(new SwipeZone(this, 0));
      // } catch (e) {
      //   console.error(e);
      // }
    } catch (e) {
      // Swal.fire({
      // title: "You've reached the maximum number of tables you can play.",
      // text: "Exit from one of your tables to add a new table.",
      // showCancelButton: false,
      // confirmButtonText: "OK",
      // color: "#ffffff",
      // background: "#006270",
      // confirmButtonColor: "#009394",
      // customClass: {
      //   title: "sweet-alert-title",
      // },})
      this.tableGames = [];
      console.error(e);
    }

    try {
      // this.userTableGames = await WebSocketManager.emitEvent(
      //   {},
      //   "poker.client-pull.user-game-tables"
      // );
      const userTablesReq = await userServices.get(
        "tables/user-tables-list-in-game"
      );
      this.userTableGames = userTablesReq.body.data;
      this.totalTableGames = this.userTableGames.length;
    } catch (e) {
      console.error(e);
    }

    // let otherTables = this.userTableGames.filter(
    //   (table) => table.id !== this.urlTableId
    // );
    let otherTables = this.userTableGames.reverse();
    // if(this.totalTableGames !== 0) {
    // if (otherTables.length !== this.totalTableGames) {
    //   /* Is table from URL in user tables? */
    //   otherTables.unshift("");
    //   for (let i = 1; i < otherTables.length; i++) {
    //     this.tableGames.push({
    //       tableGame: new TableGame(this, i + 1, otherTables[i].id),
    //       visited: false,
    //     });
    //     try {
    //       await this.tableGames[i].tableGame.init();
    //     } catch (e) {
    //       console.error(e);
    //     }
    //     this.swipeZoneList.push(new SwipeZone(this, i));
    //   }
    // } else {
    if (this.totalTableGames === 0) {
      if (this.getURLClubId()) router.push(`/lobby/${this.getURLClubId()}`);
      else router.push("/home");
    } else {
      for (let i = 0; i < otherTables.length; i++) {
        this.tableGames.push({
          tableGame: new TableGame(this, i + 1, otherTables[i].id),
          visited: i === otherTables.length - 1,
        });
        try {
          await this.tableGames[i].tableGame.init();
        } catch (e) {
          console.error(e);
        }
        this.swipeZoneList.push(new SwipeZone(this, i));
      }
      // this.changeVisitedTableGame(otherTables.length - 1)
      // router.replace(
      //   `/game/${
      //     this.tableGames[0].tableGame.tableInfo.id
      //   }/${this.getURLClubId()}`
      // );
      // this.getVisitedTable().pullGameState();
      await this.tableGames[this.totalTableGames - 1].tableGame.visitTable();
    }
    // }
    // }

    this.reserveModal = new ReservingModal(this, this.getVisitedTable(), 0);
    this.addMoreChipModal = new AddMoreChipModal(
      this,
      this.getVisitedTable(),
      0
    );
    this.chat = new Chat(this, this.getVisitedTable());
    this.realTimeResultsMenu = new RealTimeResultsMenu(
      this,
      this.getVisitedTable()
    );
    this.replayHandMenu = new ReplayHandMenu(this, this.getVisitedTable());
    this.header = new Header(this);
    // this.scale.on('resize', this.resize, this);

    this.cameras.main.startFollow(this.bg);
    this.cameras.main.followOffset.set(
      -this.gameWidth / 2,
      -this.gameHeight / 2
    );
    this.positionControls(this.gameWidth, this.gameHeight);

    const tableSettingsReq = await userServices.get("game-settings/");
    this.updateTableSettings(tableSettingsReq.body);
    this.changeVisitedTableGame(otherTables.length - 1);
  }
  createAnimation() {
    this.timeBankBlink = this.anims.create({
      key: "time-bank-blink",
      frames: this.anims.generateFrameNames(this.atlasTexture, {
        prefix: "time-bank-",
        start: 1,
        end: 3,
        zeroPad: 1,
      }),
      repeat: -1,
      frameRate: 2,
    });
    this.anims.create({
      key: "rabbit-blink",
      frames: this.anims.generateFrameNames(this.atlasTexture, {
        prefix: "rabbit-",
        start: 1,
        end: 2,
        zeroPad: 1,
      }),
      repeat: -1,
      frameRate: 4,
    });
  }
  addSounds() {
    this.soundsList = [
      this.sound.add("bet"),
      this.sound.add("call"),
      this.sound.add("check"),
      this.sound.add("allin"),
      this.sound.add("deal"),
      this.sound.add("flop"),
      this.sound.add("fold"),
      this.sound.add("raise"),
      this.sound.add("show-win-amount").setVolume(5),
      this.sound.add("stack-chips"),
      this.sound.add("time-action-warning"),
      this.sound.add("timer").setLoop(true),
      this.sound.add("win-chips"),
      this.sound.add("turn-river"),
    ];
  }
  /**
   * @param table {Table}
   * @return {boolean}
   */
  isAudioAllowed(table) {
    return (
      this.audioEnable &&
      table.tableInfo.id === this.getVisitedTable().tableInfo.id
    );
  }
  getVisitedTableGameIndex() {
    return this.tableGames.findIndex((tg) => tg.visited === true);
  }
  getTableGameById(id) {
    const theTableGame = this.tableGames.find(
      (tg) => tg.tableGame.tableId === id
    );
    if (theTableGame) {
      return theTableGame.tableGame;
    } else {
      return theTableGame;
    }
  }
  getVisitedTable() {
    //FIXME: (sentry) undefined is not an object (evaluating 'this.tableGames.find(t=>!0===t.visited).tableGame')
    // Table has been deleted.

    return this.tableGames.find((tg) => tg.visited === true).tableGame.table;
  }
  getVisitedTableGame() {
    return this.tableGames.find((tg) => tg.visited === true).tableGame;
  }
  async visitTable(tableId) {
    return new Promise((resolve, reject) => {
      userServices
        .post(`tables/visit-table`, {
          tableId: tableId,
          clubId: this.getURLClubId(),
        })
        .then((res) => {
          const visitingData = res.body.data;
          // this.tableClubId = visitingData.clubId;
          if (visitingData.deleted) {
            this.tableExpired(tableId);
            reject("Table has been deleted.");
          } else {
            resolve();
          }
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        });
    });
  }
  changeObjectsInteractivity(status) {
    this.isSceneObjectsInteractive = status;
  }
  changeVisitedTableGame(toIndex) {
    const tableGameIndex = this.getVisitedTableGameIndex();
    // if(tableGameIndex > -1) {
    this.tableGames[tableGameIndex].visited = false;
    // }
    const theTableSounds =
      this.tableGames[tableGameIndex].tableGame.table.sounds;
    theTableSounds.muteAll();

    if (toIndex < this.tableGames.length && toIndex >= 0) {
      // this.dragging = false;
      this.tableGames[toIndex].visited = true;
      this.tableGames[toIndex].tableGame.table.sounds.unmuteAll();
      this.cameraScrollTo(toIndex * this.gameWidth, toIndex, tableGameIndex);
    } else if (toIndex >= this.tableGames.length) {
      /*If the player swipes to a table after the last table*/
      this.tableGames[tableGameIndex].visited = true;
      theTableSounds.unmuteAll();
      this.cameraScrollTo(
        tableGameIndex * this.gameWidth,
        tableGameIndex,
        tableGameIndex
      ); /* Return to the last table*/
    } else if (toIndex < 0) {
      /* If the player swipes to a table before the first table*/
      this.tableGames[0].visited = true;
      this.tableGames[0].tableGame.table.sounds.unmuteAll();
      this.cameraScrollTo(0, 0, tableGameIndex); /*Return to the first table*/
    }
    if (this.getURLTableId() !== this.getVisitedTable().tableInfo.id) {
      router.replace(
        `/game/${this.getVisitedTable().tableInfo.id}/${this.getURLClubId()}`
      );
      // this.getVisitedTable().pullGameState();
      this.getVisitedTableGame().visitTable();
      const visitedTable = this.getVisitedTable();
      visitedTable.handleModals();
      visitedTable.handleReDealModal();
      if (visitedTable.isTournamentTable()) {
        visitedTable.handleTournamentRebuyModal();
        visitedTable.handleResultModal();
        visitedTable.handleAddOnModal();
        visitedTable.hideCashGameModals();
        if (visitedTable.congratsData) {
          visitedTable.showCongratsMessage();
        }
      } else {
        visitedTable.hideTournamentModals();
      }
    }
  }
  getURLTableId() {
    return +window.location.href.split("/")[
      window.location.href.split("/").length - 2
    ];
  }
  getURLClubId() {
    return +window.location.href.split("/")[
      window.location.href.split("/").length - 1
    ];
  }
  async cameraScrollTo(positionX, tableIndex, previousTableIndex) {
    /* Change the position of objects followed by the camera*/
    return new Promise((resolve, reject) => {
      this.tweens.add({
        targets: this.bg,
        x: positionX,
        // duration: positionX ? positionX / 10 : this.gameWidth / 10,
        duration: tweenConfigs.camera.duration,
        ease: tweenConfigs.camera.ease,
        onComplete: () => {
          this.allowSwiping = true;
          resolve();
        },
      });
      this.header.tablesNav.scrollTo(positionX, tableIndex, previousTableIndex);
      this.header.menu.scrollTo(positionX);
      this.header.buyInMenu.scrollTo(positionX);
      this.chat.scrollTo(positionX);
      this.realTimeResultsMenu.scrollTo(positionX);
      this.replayHandMenu.scrollTo(positionX);
    });
  }
  changeCameraPosition(positionX) {
    /* Change position of objects followed by the camera*/
    this.bg.setX(positionX);
    this.header.tablesNav.changePosition(positionX);
    this.header.menu.changePosition(positionX);
    this.header.buyInMenu.changePosition(positionX);
    this.chat.changePosition(positionX);
    this.realTimeResultsMenu.changePosition(positionX);
    this.replayHandMenu.changePosition(positionX);
  }
  async destroyTableGame(id) {
    if (this.tableGames.length - 1 > 0) {
      const theTableGameToRemove = this.getTableGameById(id);
      const theTableGameToRemoveIndex = this.getTableIndexByTableId(id);
      const theTableSounds =
        this.tableGames[theTableGameToRemoveIndex].tableGame.table.sounds;
      theTableSounds.muteAll();
      const timer = theTableSounds.find("timer");
      if (timer.isPlaying) timer.stop();
      theTableGameToRemove.table.completeTweens();
      theTableGameToRemove.removeChildren();
      this.positionsWereControlled = false;
      for (
        let i = theTableGameToRemoveIndex + 1;
        i < this.totalTableGames;
        i++
      ) {
        this.tableGames[i].tableGame.updateTableNumber(
          this.tableGames[i].tableGame.tableNumber - 1
        );
        this.tableGames[i].tableGame.table.completeTweens();
        this.tableGames[i].tableGame.reposition(
          this.gameWidth,
          this.gameHeight
        );
        this.tableGames[i].tableGame.table.setIdle();
        this.tableGames[i].tableGame.table.pullGameState();

        this.swipeZoneList[i].swipeIndex = this.swipeZoneList[i].swipeIndex - 1;
        this.swipeZoneList[i].positionControls(this.gameWidth, this.gameHeight);
      }
      this.positionsWereControlled = true;
      // const toIndex = theTableGameToRemoveIndex === this.totalTableGames -1 ? theTableGameToRemoveIndex -1 : theTableGameToRemoveIndex;
      this.tableGames.splice(theTableGameToRemoveIndex, 1);
      theTableGameToRemove.tableGame = null;
      this.totalTableGames -= 1;

      this.tableGames[0].visited = true;
      this.tableGames[0].tableGame.table.sounds.unmuteAll();
      this.header.tablesNav.removeTable(theTableGameToRemoveIndex);
      this.header.tablesNav.reposition(
        this.gameWidth,
        this.gameHeight,
        this.tableGames[0].tableGame.table.displayWidth,
        this.tableGames[0].tableGame.table.displayHeight
      );
      this.header.tablesNav.activateVisitedMiniTable();
      await this.cameraScrollTo(0, 0, theTableGameToRemove);
      // this.tableGames[theTableGameToRemoveIndex].visited = true;
      // this.tableGames[
      //   theTableGameToRemoveIndex
      // ].tableGame.table.sounds.unmuteAll();
      // this.header.tablesNav.removeTable(theTableGameToRemoveIndex);
      // this.header.tablesNav.positionControls(
      //   this.gameWidth,
      //   this.gameHeight,
      //   this.tableGames[0].tableGame.table.displayWidth,
      //   this.tableGames[0].tableGame.table.displayHeight
      // );
      // this.header.tablesNav.miniTableToMove.setX(
      //   this.header.tablesNav.tables[theTableGameToRemoveIndex].miniTable.x
      // );
      // this.header.tablesNav.activateVisitedMiniTable();

      // if (theTableGameToRemoveIndex === this.totalTableGames) {
      //   this.tableGames[theTableGameToRemoveIndex - 1].visited = true;
      //   this.tableGames[
      //     theTableGameToRemoveIndex - 1
      //   ].tableGame.table.sounds.unmuteAll();
      //   this.header.tablesNav.removeTable(theTableGameToRemoveIndex);
      //   this.header.tablesNav.positionControls(
      //     this.gameWidth,
      //     this.gameHeight,
      //     this.tableGames[0].tableGame.table.displayWidth,
      //     this.tableGames[0].tableGame.table.displayHeight
      //   );
      //   this.header.tablesNav.activateVisitedMiniTable();
      //   await this.cameraScrollTo(
      //     (theTableGameToRemoveIndex - 1) * this.gameWidth,
      //     theTableGameToRemoveIndex - 1,
      //     theTableGameToRemove
      //   );
      // } else {
      //   this.tableGames[theTableGameToRemoveIndex].visited = true;
      //   this.tableGames[
      //     theTableGameToRemoveIndex
      //   ].tableGame.table.sounds.unmuteAll();
      //   this.header.tablesNav.removeTable(theTableGameToRemoveIndex);
      //   this.header.tablesNav.positionControls(
      //     this.gameWidth,
      //     this.gameHeight,
      //     this.tableGames[0].tableGame.table.displayWidth,
      //     this.tableGames[0].tableGame.table.displayHeight
      //   );
      //   this.header.tablesNav.miniTableToMove.setX(
      //     this.header.tablesNav.tables[theTableGameToRemoveIndex].miniTable.x
      //   );
      //   this.header.tablesNav.activateVisitedMiniTable();
      // }
      if (this.getURLTableId() !== this.getVisitedTable().tableInfo.id) {
        router.replace(
          `/game/${this.getVisitedTable().tableInfo.id}/${this.getURLClubId()}`
        );
        // this.getVisitedTable().pullGameState();
        this.getVisitedTableGame().visitTable();
        const visitedTable = this.getVisitedTable();
        visitedTable.handleModals();
        visitedTable.handleReDealModal();
        if (visitedTable.isTournamentTable()) {
          visitedTable.handleTournamentRebuyModal();
          visitedTable.handleResultModal();
          visitedTable.handleAddOnModal();
          if (visitedTable.congratsData) {
            visitedTable.showCongratsMessage();
          }
        }
      }
      const swipeZoneToDelete = this.swipeZoneList.splice(
        theTableGameToRemoveIndex,
        1
      );
      swipeZoneToDelete[0].destroy();
    } else {
      router.push(
        `/lobby/${
          this.getVisitedTableGame().getClubId() || this.getURLClubId()
        }`
      );
    }
  }
  async handleGameState(gameState) {
    let theTable = this.getTableGameById(gameState.tableId);
    if (theTable) {
      theTable.handleGameState(gameState);
    } else {
      try {
        const userTablesReq = await userServices.get(
          "tables/user-tables-list-in-game"
        );
        const serverTables = userTablesReq.body.data;
        if (serverTables.find((st) => st.id === gameState.tableId)) {
          if (gameState.playerInfo && gameState.playerInfo.previousTable) {
            theTable = this.getTableGameById(
              gameState.playerInfo.previousTable
            );
            if (theTable) {
              theTable.changeTableTo(gameState.tableId);
              theTable.handleGameState(gameState);
            } else {
              window.location.href = `/game/${
                gameState.tableId
              }/${this.getURLClubId()}`;
            }
          } else {
            console.log("you've got a game state of a new table...");
            Sentry.captureException(
              "you've got a game state of a new table...",
              { extraData: gameState }
            );
            window.location.href = `/game/${
              gameState.tableId
            }/${this.getURLClubId()}`;
          }
        } else {
          console.log("you've got a game state of a wrong table...");
          Sentry.captureException(
            "you've got a game state of a wrong table...",
            { extraData: gameState }
          );
        }
      } catch (e) {
        console.error(e);
      }
    }
  }
  handleMessages(response) {
    if (this.getVisitedTable().tableInfo.id === response.tableId) {
      const tableGame = this.getTableGameById(response.tableId);
      if (tableGame) {
        tableGame.table.handleMessages(response);
      }
    }
  }

  tableExpired(tableId) {
    if (this.getURLTableId() !== tableId) return;
    this.registry.set("showGameStats", false);
    if (!this.tweenEnable) return;
    this.expiredTableToShow = tableId;
    this.alertify.dismissAll();
    this.changeObjectsInteractivity(false);
    this.registry.set("showGameStats", true);
  }
  restartScene() {
    this.alertify.dismissAll();
    this.lockScreen.show("loading...");
    document.removeEventListener(
      VisibilityManager.visibilityChange,
      VisibilityManager.visibilityChangeCallBack
    );
    this.scene.restart();
  }
  async deleteTable(expiredTableId) {
    if (this.expiredTables.findIndex((tId) => tId === expiredTableId) === -1) {
      if (this.getTableIndexByTableId(expiredTableId) !== -1) {
        this.destroyTableGame(expiredTableId);
      }
    }
    for (let j = 0; j < this.expiredTables.length; j++) {
      this.time.addEvent({
        delay: 2000 * j, // ms
        callback: destroyTable,
        args: [j],
        callbackScope: this,
        loop: false,
      });
    }
    async function destroyTable(j) {
      await this.destroyTableGame(this.expiredTables[j].id);
    }
    // if (this.tableGames.length > 0) {
    // tableGamesIds = this.tableGames.map(
    //   (t) => t.tableGame.table.tableInfo.id
    // );
    // expiredTablesIds = this.expiredTables.map((t) => t.id);
    // nonExpiredTablesIds = tableGamesIds.filter(
    //   (x) => !expiredTablesIds.includes(x)
    // );
    // const tableGame = this.tableGames.find( t => t.tableGame.table.tableInfo.id !== id);
    // if (nonExpiredTablesIds.length) {
    //   if (expiredTablesIds.length) {
    // router.push(`/game/${nonExpiredTablesIds[0]}/${this.getURLClubId()}`);
    // this.restartScene();
    //   }
    // } else {
    //   router.push(`/lobby/${this.getVisitedTableGame().getClubId()}`);
    // }
    // } else {
    //   router.push(
    //     `/lobby/${this.getVisitedTableGame().getClubId() ||
    //       this.getURLClubId()}`
    //   );
    // }
  }
  manageAutoSwitchTables(tableInTurnId) {
    if (this.autoSwitchTables) {
      const fromTable = this.getVisitedTable();
      /* Refrain from switching tables while the rebuy modal of the tournament is open */
      if (
        fromTable.isTournamentTable() &&
        fromTable.gameState.state === "Rebuy" &&
        fromTable.gameState.playerInfo &&
        fromTable.gameState.rebuyPlayers.includes(
          fromTable.gameState.playerInfo.id
        )
      )
        return;
      if (
        !fromTable.isYourSelfPlayerTurn() &&
        !this.reserveModal.showInProgress &&
        !this.addMoreChipModal.showInProgress
      ) {
        this.changeVisitedTableGame(this.getTableIndexByTableId(tableInTurnId));
        this.chat.hide();
        this.replayHandMenu.hide();
        this.realTimeResultsMenu.hide();
      }
    }
  }
  getTableIndexByTableId(id) {
    return this.tableGames.findIndex(
      (tg) => tg.tableGame.table.tableInfo.id === id
    );
  }
  hasTournamentTable() {
    return !!this.tableGames.find((tg) =>
      tg.tableGame.table.isTournamentTable()
    );
  }
  hasCashGameTable() {
    return !!this.tableGames.find(
      (tg) => !tg.tableGame.table.isTournamentTable()
    );
  }
  updateTableSettings(settings) {
    // settings = {
    //     "textMessage": false,
    //     "soundEffects": true,
    //     "vibration": true,
    //     "autoSwitchTables": false,
    //     "customizedActionButtons": true,
    //     "betButton1": "ThreeFourthPot",
    //     "betButton2": "TwoThirdPot",
    //     "betButton3": "HalfPot"
    // }
    if (!settings["soundEffects"]) {
      this.sound.volume = 0;
    } else {
      this.sound.volume = 1;
    }
    this.chat.block(settings["textMessage"]);
    this.autoSwitchTables = settings["autoSwitchTables"];
    this.vibrationAllowed = settings["vibration"];
    store.commit("setCardsColour", settings["cardsColour"]);
    if (settings["customizedActionButtons"]) {
      const betButtons = [
        settings["betButton1"],
        settings["betButton2"],
        settings["betButton3"],
      ];
      this.tableGames.forEach((tg) => {
        tg.tableGame.table.buttonManager.raiseBtn.setFastBetButtonsTxt(
          betButtons
        );
        // tg.tableGame.table.buttonManager.betBtn.setFastBetButtonsTxt(
        //   betButtons
        // );
      });
    }
  }
  async pullGameState() {
    let promisesList = [];
    this.tableGames.forEach((tg) => {
      promisesList.push(tg.tableGame.table.pullGameState());
    });
    return new Promise((resolve, reject) => {
      Promise.all(promisesList)
        .then(() => resolve())
        .catch((e) => reject(e));
    });
  }
  async getPlayerLocation() {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: "GPS restriction is activated for this table.",
        html: "Do you want to sit?<br> We suggest you turn your VPN on.",
        showCancelButton: true,
        confirmButtonText: "OK",
        color: "#ffffff",
        background: "#006270",
        confirmButtonColor: "#009394",
        cancelButtonColor: "#009394",
        customClass: {
          title: "sweet-alert-title",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.userLatitude && this.userLongitude) {
            resolve({ lat: this.userLatitude, lng: this.userLongitude });
          } else {
            geoLocationService
              .getUserLocation()
              .then((res) => {
                resolve({ lat: res.latitude, lng: res.longitude });
              })
              .catch((err) => {
                reject(err);
              });
          }
        } else {
          reject();
        }
      });
    });
  }
  clearATimeout(t) {
    this.timeouts.splice(this.timeouts.indexOf(t), 1);
  }
  setATimeout(callback, ms) {
    const timeout = setTimeout(() => {
      callback();
      this.timeouts.splice(this.timeouts.indexOf(timeout), 1);
    }, ms);
    this.timeouts.push(timeout);
  }
  resize(gameSize) {
    this.gameWidth = gameSize.width;
    this.gameHeight = gameSize.height;
    this.game.scale.gameSize.setSize(this.gameWidth, this.gameHeight);
    this.cameras.resize(this.gameWidth, this.gameHeight);
    this.cameras.main.followOffset.set(
      -this.gameWidth / 2,
      -this.gameHeight / 2
    );
    this.positionControls(this.gameWidth, this.gameHeight);
  }
  positionControls(width, height) {
    this.bg.setScale(width / this.bg.width, height / this.bg.height);
    this.swipeZoneList.forEach((zone) => {
      zone.positionControls(width, height);
      // zone.positionControls(width > height ? width/2 : width, height);
    });
    this.tableGames.forEach((tableGame, index) => {
      tableGame.tableGame.positionControls(width, height);
      // tableGame.tableGame.positionControls(width > height ? width/2 : width, height);
      if (tableGame.visited) {
        this.cameras.main.centerOn(index * width + width / 2, height / 2);
        this.bg.setPosition(index * width, 0);
      }
    });
    const visitedTable = this.getVisitedTable();
    this.header.positionControls(
      width,
      // width > height ? width/2 : width,
      height,
      visitedTable.displayWidth,
      visitedTable.displayHeight
    );
    // this.reserveModal.positionControls(
    //   visitedTable.displayWidth,
    //   visitedTable.displayHeight,
    //   visitedTable.x,
    //   visitedTable.y
    // );
    // this.addMoreChipModal.positionControls(
    //   visitedTable.displayWidth,
    //   visitedTable.displayHeight,
    //   visitedTable.x,
    //   visitedTable.y
    // );
    this.chat.positionControls(
      visitedTable.displayWidth,
      visitedTable.displayHeight
    );
    this.realTimeResultsMenu.positionControls(
      visitedTable.displayWidth,
      visitedTable.displayHeight
    );
    this.replayHandMenu.positionControls(
      visitedTable.displayWidth,
      visitedTable.displayHeight
    );
    // this.lockScreen.positionControls();
    this.setATimeout(() => {
      this.lockScreen.hide();
      if (this.scene.isActive("PreloadScene")) {
        this.scene.stop("PreloadScene");
        this.scene.remove("BootScene");
        this.scene.remove("PreloadScene");
      }
      this.connectionFailedTimer.destroy();
      if (store.getters.getReplayGameInfo.tableId)
        setTimeout(() => {
          WebSocketManager.replayGameStatesByAdmin(
            store.getters.getReplayGameInfo
          );
        }, 1000);

      // setTimeout(() => {
      //   WebSocketManager.test();
      // }, 1000)
    }, 1000);
    this.positionsWereControlled = true;
    VisibilityManager.handleVisibilityChange(this);
    if (WebSocketManager.socket && WebSocketManager.socket.connected) {
      WebSocketManager.listenGameEvents();
    }
  }
}
